import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-217">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onClick={onClose} className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-4 bg-black/60 backdrop-blur-sm" data-id="element-218">
          <motion.div initial={{
        y: 30,
        opacity: 0,
        scale: 0.98
      }} animate={{
        y: 0,
        opacity: 1,
        scale: 1
      }} exit={{
        y: 30,
        opacity: 0,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative w-full sm:max-w-lg max-h-[85vh] bg-navy-900 border border-gold-500/30 sm:rounded-sm rounded-t-xl shadow-2xl flex flex-col" data-id="element-219">
            {/* Header */}
            <div className="flex items-center justify-between p-5 border-b border-gold-500/20 sticky top-0 bg-navy-900 rounded-t-xl sm:rounded-t-sm z-10" data-id="element-220">
              <h3 className="font-serif text-xl text-cream-100 pr-6" data-id="element-221">
                {title}
              </h3>
              <button onClick={onClose} aria-label="Cerrar" className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-cream-300 hover:text-gold-400 hover:bg-gold-500/10 transition-colors" data-id="element-222">
                <X size={18} data-id="element-223" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto p-5 sm:p-6 text-[14px] text-cream-300/90 font-light leading-relaxed space-y-4" data-id="element-224">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}